import { isValid } from 'iban';
import { t } from '../../app/i18n';
import rules from './rules';
import { call } from 'redux-saga/effects';

const email = [...rules.required, { type: 'email', message: t('E-mail nie je správny') }];

const iban = [
  ...rules.required,
  {
    validator: (rule, value, callback) =>
      callback(value && !isValid(value.replace(' ', '')) ? t('IBAN nie je správny') : undefined),
  },
];

const idCardNumber = [
  ...rules.required,
  {
    validator: (rule, value, callback) =>
      callback(
        value && !/^([A-Za-z]{2}[0-9]{6})$/.test(value)
          ? t('Číslo občianskeho preukazu nie je správne')
          : undefined
      ),
  },
];

const passwordWithLimit = [
  ...rules.required,
  { validator: (rule, value, callback) =>
    callback(
      value &&
        !/^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/.test(value)
        ? t('Heslo musí mať minimálne 8 znakov a musí obsahovať malé písmeno, veľké písmeno a aspoň jednu číslicu.')
        : undefined
    ),
  },
];

const personalNumber = [
  ...rules.required,
  {
    validator: (rule, value, callback) =>
      callback(
        value &&
        !/^([0-9]{2}([0,5][1-9]|[1,6][0-2])([0-2][0-9]|[3][0,1])?[0-9]{3,4})$/.test(value)
        ? t('Rodné číslo nie je správne')
        : undefined
      ),
  },
];

const telephoneNumber = [
  ...rules.required,
  {
    validator: (rule, value, callback) =>
      callback(
        value &&
        !/^([0][9][0-9]{2}[ ]?([0-9]{6}|[0-9]{3}[ ][0-9]{3}|[0-9]{2}[ ][0-9]{2}[ ][0-9]{2}))$/.test(
          value
        )
          ? t('Telefónne číslo nie je správne')
          : undefined
      ),
  },
];

const optionalTelephoneNumber = [
  {
    validator: (rule, value, callback) =>
      callback(
        value &&
          !/^([0][9][0-9]{2}[ ]?([0-9]{6}|[0-9]{3}[ ][0-9]{3}|[0-9]{2}[ ][0-9]{2}[ ][0-9]{2}))$/.test(
            value
          )
          ? t('Telefónne číslo nie je správne')
          : undefined
      ),
  },
];

const additionalTelephoneNumber = [
  ...rules.required,
  {
    validator: (rule, value, callback) =>
      callback(
        value && value.length > 20
          ? t('Telefónne číslo je príliš dlhé')
          : undefined
      ),
  },
];

const zip = [
  {
    validator: (rule, value, callback) =>
      callback(
        value && !/^([0-9]{3}[ ]?[0-9]{2})$/.test(value) ? t('PSČ nie je správne') : undefined
      ),
  },
];

const checkRepeatPassword = (form, repeatPasswordDirty) => (rule, value, callback) => {
  if (value && repeatPasswordDirty) {
    form.validateFields(['repeatPassword'], { force: true });
  }

  callback();
};

const checkPassword = form => (rule, value, callback) => {
  if (value && value !== form.getFieldValue('password')) {
    callback(t('Heslá sa nezhodujú'));
  } else {
    callback();
  }
};

const checkValidPersonalNumber = form => (rule, value, callback) => {
  if (!value) {
    callback(t('Rodné čislo je povinný údaj'))
  }

  if (value.length < 9 || value.length > 10) {
    callback(t('Dĺžka rodného čísla nie je správna'))
  }

  let day, month, year

  year = Number(value.substring(0, 2))
  month = Number(value.substring(2, 4))
  day = Number(value.substring(4, 6))

  if (value.length == 9 && (year >= 54)) {
    callback('Rodné čislo nie je správne');
  }

  if (value.length == 10) {
    let mod = Number(value.substring(0, 9)) % 11;
    let lastNumber = Number(value.substring(9));
    if (mod == 10) {
      if (lastNumber != 0) {
        callback('Rodné čislo nie je správne');
      }
    } else if (lastNumber != mod) {
      callback('Rodné čislo nie je správne');
    }
  }

  if(!isDayAndMonthValid(value, year, month, day)) {
    callback('Rodné čislo nie je správne');
  }
  callback();
};

function isDayAndMonthValid(value, year, month, day) {
  year = getYearWithHunders(year, value);
  month = getRealMonth(year, month);
  
  if (month == 0 || month > 12) {
    return false;
  }
  
  if (day == 0) {
    return false;
  }
  
  let date = new Date();
  date.setYear(year);
  date.setMonth(month - 1);
  
  let daysInMonth = daysInMonthCount(year, month);
  
  if (daysInMonth < day) {
    return false;
  }
  
  return true;
};

function getRealMonth(year, month) {
  if ((month > 70) && (year > 2003)) {
    month -= 70;
  } else if (month > 50) {
    month -= 50;
  } else if ((month > 20) && (year > 2003)) {
    month -= 20;
  }
  
  return month;
};

function getYearWithHunders(year, value) {
  if (value.length == 9) {
    return year + 1900;
  }
  if (year > (new Date().getFullYear()) % 100) {
    return year + 1900;
  } else {
    return year + 2000;
  }
}

function daysInMonthCount(year, month) {
  let daysInMonth = new Date(year, month, 0).getDate();
  return Number(daysInMonth);
}



const interestBonusValue = [
  {
    validator: (rule, value, callback) => {
      if (value === null || value === undefined || String(value).trim() === '') {
        callback();
        return;
      }

      const stringValue = String(value).trim();
      const numValue = Number(stringValue);

      if (isNaN(numValue)) {
        callback(new Error(t('Hodnota musí byť platné číslo.')));
        return;
      }

      if (numValue < 0 || numValue > 100) {
        callback(new Error(t('Hodnota bonusu musí byť medzi 0 a 100.')));
        return;
      }

      const decimalPart = stringValue.split('.')[1];
      if (decimalPart && decimalPart.length > 2) {
        callback(new Error(t('Hodnota bonusu môže mať maximálne 2 desatinné miesta.')));
        return;
      }

      callback();
    },
  },
];

export default {
  email,
  iban,
  idCardNumber,
  passwordWithLimit,
  personalNumber,
  telephoneNumber,
  optionalTelephoneNumber,
  additionalTelephoneNumber,
  zip,
  checkRepeatPassword,
  checkPassword,
  checkValidPersonalNumber,
  interestBonusValue,
};



// WEBPACK FOOTER //
// ./src/common/rules/accountRules.js